import ChevronIcon from 'components/icons/ChevronIcon';
import CrossIcon from 'components/icons/CrossIcon';
import WithlocalsLogoSmall from 'components/icons/WithlocalsLogoSmall';
import useIsMobile from 'hooks/useIsMobile';
import useBackLink from 'modules/host-profile/hooks/useBackLink';
import React, { ReactNode, useState } from 'react';

const CSS = require('./PageLayout.module.scss');

const TOOL_TIP_TEXT =
  'This information will help us match you with the right Withlocals Originals experiences to get more bookings.';

interface PageLayoutProps {
  children: ReactNode;
  title: string;
  onQuestionMark?: () => void;
  noHelp?: boolean;
  helpText?: string;
}

function PageLayout({
  children,
  title,
  onQuestionMark,
  noHelp,
  helpText,
}: PageLayoutProps) {
  const [showToolTip, setToolTipVisibility] = useState(false);
  const isMobile = useIsMobile();
  const backLink = useBackLink();
  const toggleToolTip = () => setToolTipVisibility(!showToolTip);
  const closeToolTip = () => setToolTipVisibility(false);

  return (
    <div className={CSS.Container}>
      <aside className={CSS.Side}>
        <WithlocalsLogoSmall width={53} height={28} />
        <div className={CSS.SideContent}>
          <div>
            <a className={CSS.BackButton} href={backLink.url}>
              <ChevronIcon
                direction="left"
                width={9}
                height={15}
                className={CSS.ChevronIcon}
              />{' '}
              <span>{backLink.label}</span>
            </a>
          </div>
          <h3 className={CSS.SubTitle}>profile management</h3>
          <h1 className={CSS.Title}>
            {title}
            {(isMobile || onQuestionMark) && !noHelp && (
              <button
                className={CSS.ToolTipButton}
                onClick={onQuestionMark ? onQuestionMark : toggleToolTip}
              >
                ?
              </button>
            )}
          </h1>
          {showToolTip && (
            <div className={CSS.ToolTip}>
              {helpText || TOOL_TIP_TEXT}
              <button className={CSS.CloseButton} onClick={closeToolTip}>
                <CrossIcon className={CSS.CrossIcon} />
              </button>
            </div>
          )}
        </div>
      </aside>
      <div className={CSS.ContentContainer}>{children}</div>
    </div>
  );
}

export default PageLayout;
